import React, { useState, useEffect } from 'react';
import { Button, Typography, IconButton } from '@mui/material';
import CallEndIcon from '@mui/icons-material/CallEnd';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import { Room } from 'livekit-client';
import { useTranslation } from 'react-i18next';
import { useControlBarStyles } from './ControlBar.styles';
import { VoiceState } from '../../types/VoiceState';
import { AllParticipantStates } from '../../types/roomManager.types';

interface ControlBarProps {
  state: VoiceState;
  onConnectButtonClicked: () => void;
  room: Room;
  participantStates?: AllParticipantStates;
}

export const ControlBar = ({ state, room, participantStates }: ControlBarProps) => {
  const { classes } = useControlBarStyles();
  const { t } = useTranslation();
  const [isMicEnabled, setIsMicEnabled] = useState(true);

  useEffect(() => {
    if (room && room.localParticipant) {
      setIsMicEnabled(room.localParticipant.isMicrophoneEnabled);
    }
  }, [room, state]);

  const handleDisconnect = () => {
    room.disconnect();
  };

  const toggleMicrophone = async () => {
    if (room && room.localParticipant) {
      const newState = !isMicEnabled;
      await room.localParticipant.setMicrophoneEnabled(newState);
      setIsMicEnabled(newState);
    }
  };

  const isEndCallDisabled = !participantStates?.agent?.connected;

  return (
    <div className={classes.container}>
      {state === VoiceState.CONNECTING ? (
        <div className={classes.connectingContainer}>
          <div className={classes.loadingDot}></div>
          <Typography variant="body1" className={classes.connectingText}>
            {t('agentPage.status.connectingToAgent')}
          </Typography>
        </div>
      ) : (
        <div className={classes.controlsContainer}>
          <IconButton
            className={`${classes.micButton} ${isMicEnabled ? classes.micButtonActive : classes.micButtonMuted}`}
            onClick={toggleMicrophone}
            size="large">
            {isMicEnabled ? <MicIcon /> : <MicOffIcon />}
          </IconButton>

          <Button
            variant="contained"
            className={classes.endCallButton}
            onClick={handleDisconnect}
            disabled={isEndCallDisabled}
            startIcon={<CallEndIcon />}>
            {t('agentPage.status.endCall')}
          </Button>
        </div>
      )}
    </div>
  );
};
